import moment from 'moment';

const getClockInDisabledState = (isClockInToday, isClockInTomorrow) => {
  if (isClockInToday && moment().isBefore(moment().set({ hour: 19, minute: 0, second: 0 }))) {
    return 'attendance.wait_until_next_shift_desc';
  }

  if (isClockInToday && isClockInTomorrow && moment().isAfter(moment().set({ hour: 19, minute: 0, second: 0 }))) {
    return 'attendance.already_clock_in_both_days_desc';
  }

  return '';
};

export default getClockInDisabledState;
